import { cn } from "@nutrayan/ui";

type Tone = "success" | "warning" | "danger" | "neutral";

const TONES: Record<Tone, string> = {
  success: "bg-forest/10 text-forest",
  warning: "bg-gold/15 text-gold",
  danger: "bg-terracotta/10 text-terracotta",
  neutral: "bg-charcoal/10 text-ink",
};

// Map backend status enums (UserStatus / PasswordStatus) to a tone + readable label.
const STATUS_META: Record<string, { tone: Tone; label: string }> = {
  ACTIVE: { tone: "success", label: "Active" },
  SUSPENDED: { tone: "danger", label: "Suspended" },
  DELETED: { tone: "neutral", label: "Deleted" },
  PENDING_PROFILE: { tone: "warning", label: "Pending" },
  PENDING_SETUP: { tone: "warning", label: "Password pending" },
  LOCKED: { tone: "danger", label: "Locked" },
};

export function StatusBadge({
  status,
  className,
}: {
  status?: string | undefined;
  className?: string | undefined;
}) {
  const meta = status ? STATUS_META[status] : undefined;
  const tone = meta?.tone ?? "neutral";
  const label = meta?.label ?? status ?? "—";
  return (
    <span
      className={cn(
        "text-caption inline-flex items-center rounded-full px-2 py-0.5 font-medium",
        TONES[tone],
        className,
      )}
    >
      {label}
    </span>
  );
}
